import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const createConfiguration = createAsyncThunk("createConfiguration", async ({ data }) => {
	const token = localStorage.getItem("auth_token");
	const body = {
		data: [
			{
				language: "en",
				mission: data?.gm_en,
				vision: data?.gv_en,
				values: data?.gva_en,
			},
			{
				language: "si",
				mission: data?.gm_si,
				vision: data?.gv_si,
				values: data?.gva_si,
			},
			{
				language: "ta",
				mission: data?.gm_ta,
				vision: data?.gv_ta,
				values: data?.gva_ta,
			},
		],
	};

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.patch(`vision/update`, body, config);
	message.success("Configurations successfully updated!");
	return response.data;
});

const configurationCreateSlice = createSlice({
	name: "configurationCreate",
	initialState: {
		isLoading: false,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(createConfiguration.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(createConfiguration.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(createConfiguration.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default configurationCreateSlice.reducer;
